<template>
    <div class="content_con">
        <p class="text-center" style="margin-bottom: 20px;"><span class="title">东进公司岗位承包采购项目竞争性磋商公告</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span
                class="content">一、 广东东进有害生物防控技术有限公司，拟对东进公司岗位承包采购项目（采购项目编号：DJFK-GW-05-01-002（2024））所需的货物及服务采用竞争性磋商方式进行采购，欢迎符合资格条件的供应商参加</span>
        </p>
        <p class="text-left text-indent-37 line-height-39 content">二、<span class="heading">采购项目名称</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="content heading">广东东进有害生物防控技术有限公司岗位承包采购项目</span>
        </p>
        <p class="text-left text-indent-37 line-height-39">三、<span class="heading">采购项目编号</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="content heading">DJFK-GW-05-01-002（2024）</span>
        </p>
        <p class="text-left text-indent-37 line-height-39">四、<span class="heading">采购项目预算金额</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="content heading">本项目按单价报价，据实际进场人员数量和考核据实结算。</span>
        </p>
        <el-table :data="tableData" style="width: 100%;" border>
            <el-table-column prop="purchasePackage" label="包组号" />
            <el-table-column prop="projectContent" label="采购标的" />
            <el-table-column prop="serviceUnitQuantity" label="数量" />
            <el-table-column prop="serviceTerm" label="技术规格、参数及要求" />
        </el-table>
        <p class="text-left text-indent-37 line-height-39">五、<span class="heading">项目内容及需求</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="number">1</span>
            <span class="content">、采购人的具体采购需求：详见磋商文件中的“用户需求书”。</span>
        </p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="number">2</span>
            <span class="content">、供应商必须对项目进行整体响应，不允许仅对其中部分内容进行响应。</span>
        </p>
        <p class="text-left text-indent-37 line-height-39">六、<span class="heading">供应商资格要求</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="number">1</span>
            <span class="content heading">、一般资格要求：</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">（1）</span>
            <span
                class="content">供应商须为在中华人民共和国境内登记注册的具有独立承担民事责任能力的法人或其他组织【提供《营业执照》复印件（加盖公章）或《事业单位法人证书》复印件（加盖公章）或其他主体证书复印件（加盖公章）】。</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">（2）</span>
            <span
                class="content">参加采购活动前三年内，在经营活动中没有重大违法记录（须提供书面声明）。重大违法记录，是指供应商因违法经营受到刑事处罚或者责令停产停业、吊销许可证或者执照、较大数额罚款等行政处罚。（根据财库〔2022〕3号文，“较大数额罚款”认定为200万元以上的罚款，法律、行政法规以及国务院有关部门明确规定相关领域“较大数额罚款”标准高于200万元的，从其规定，如有最新发文通知，按最新文件执行）。</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">（3）</span>
            <span class="content">供应商的单位负责人为同一人或者存在直接控股、管理关系的不同供应商，不得参加同一合同项下的采购活动。</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">（4）</span>
            <span class="content">未被列入“信用中国”网站(www.creditchina.gov.cn
                )“记录失信被执行人或重大税收违法失信主体或政府采购严重违法失信行为”记录名单。以供应商于本项目开标日前1个月内，在“信用中国”网站查询结果为准，供应商需提供相关证明资料。</span>
        </p>
        <p class="text-indent-37 line-height-39 text-autospace">
            <span class="number">（5）</span>
            <span
                class="content">供应商未被列入东实集团及下属企业采购黑名单。【以东莞实业投资控股集团有限公司发文（东实通〔2021〕44号）、（东实通〔2021〕98号）及各下属公司发文为准】。</span>
        </p>
        <p class="text-left text-indent-37 line-height-39">七、<span class="heading">磋商文件获取方式</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="content">不进行实名登记报名。拟参加投标的供应商可自行在东莞实业投资控股集团有限公司-招标采购栏目（http://www.dgsy.com.cn/）下载采购文件。</span>
        </p>
        <p class="text-left text-indent-37 line-height-39">八、<span class="heading">提交响应文件开始时间</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="content">2024年12月4日下午14时30分至15时00分；（北京时间）</span>
        </p>
        <p class="text-left text-indent-37 line-height-39">九、<span class="heading">提交响应文件截止及开标时间</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="content">2024年12月16日下午15时00分（北京时间）；</span>
        </p>
        <p class="text-left text-indent-37 line-height-39">九、<span class="heading">提交响应文件及磋商地址</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="content">东莞市南城街道中天商业街28号1栋209室东进公司。</span>
        </p>
        <p class="text-left text-indent-37 line-height-39">十、<span class="heading">联系事项</span></p>
        <el-table :data="contactData" style="width: 100%;" border>
            <el-table-column label="1、" width="50" />
            <el-table-column prop="danw" label="采购单位" width="220" />
            <el-table-column prop="dian" label="" width="40" align="center" />
            <el-table-column prop="content" label="" />
        </el-table>
        <p class="text-left text-indent-37 line-height-39"><span class="heading">十一、本项目相关公告发布媒体发布</span></p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="number">1</span>
            <span class="content">、东莞实业投资控股集团有限公司-招标采购栏目：http://www.dgsy.com.cn/。</span>
        </p>
        <p class="text-left text-indent-37 line-height-39">
            <span class="number">2</span>
            <span class="content">、相关公告在法定媒体上公布之日即视为有效送达，不再另行通知。</span>
        </p>
        <p class="text-center text-indent-243 line-height-39">
            <span class="content">广东东进有害生物防控技术有限公司</span>
        </p>
        <p class="text-center text-indent-336 line-height-39">
            <span class="number">2024</span>
            <span class="content">年</span>
            <span class="number">12</span>
            <span class="content">月</span>
            <span class="number">3</span>
            <span class="content">日</span>
        </p>
        <p class="file-link-box"><a class="group1 cboxElement"
                href="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_doc.gif"
                title=""><img class="icon"
                    src="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_doc.gif"></a><a
                class="file-link" href="/20241203/02/竞争性磋商文件（东进公司岗位承包采购项目）.docx"
                title="竞争性磋商文件(（东进公司岗位承包采购项目）.docx">竞争性磋商文件（东进公司岗位承包采购项目）.docx</a></p>
        <p class="file-link-box"><a class="group1 cboxElement"
                href="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif"
                title=""><img class="icon"
                    src="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif"></a><a
                class="file-link" href="/20241203/02/竞争性磋商文件（东进公司岗位承包采购项目）.pdf"
                title="竞争性磋商文件(（东进公司岗位承包采购项目）.pdf">竞争性磋商文件（东进公司岗位承包采购项目）.pdf</a></p>
    </div>
</template>
<script>
export default {
    name: "DocDisplay",
    data() {
        return {
            tableData: [
                { purchasePackage: 'A1', projectContent: '林业防制岗位', serviceUnitQuantity: '5家', serviceTerm: '详见第三部分用户需求书' },
                { purchasePackage: 'A2', projectContent: '消杀人员岗位', serviceUnitQuantity: '2家', serviceTerm: '' },
                { purchasePackage: 'A3', projectContent: '空调等设备清洗消毒维护岗位', serviceUnitQuantity: '2家', serviceTerm: '' }
            ],
            contactData: [
                { index: '1、', danw: '采购单位', dian: ':', content: '广东东进有害生物防控技术有限公司' },
                { item: '  ', danw: '地址', dian: ':', content: '东莞市南城街道中天商业街28号1栋209室' },
                { item: '  ', danw: '采购项目联系人', dian: ':', content: '翟智伟' },
                { item: '  ', danw: '电话', dian: ':', content: '13829104552' }
            ]
        };
    },
};
</script>

<style lang="scss" scoped>
.content_con {
    font-size: 14px;
    font-family: "宋体", Arial;
    padding: 0px 50px;
    color: #515050;

    a {
        text-decoration: none;
        color: inherit;
    }

    .fa {
        color: #333;
        font-size: 12px;
    }

    .line-height-2em {
        line-height: 2em;
    }

    .text-center {
        text-align: center;
    }

    .margin-bottom-21 {
        margin-bottom: 21px;
    }

    .title {
        font-size: 27px;
        font-family: 方正小标宋简体;
    }

    .text-indent-37 {
        text-indent: 37px;
    }

    .line-height-39 {
        line-height: 39px;
    }

    .content {
        font-weight: 200;
        font-size: 19px;
        font-family: 仿宋_GB2312;
    }

    .heading {
        font-size: 19px;
        font-family: 黑体;
    }

    .number {
        font-size: 19px;
        font-family: 'Times New Roman', 'serif';
    }

    .underline {
        text-decoration: underline;
    }

    .text-left {
        text-align: left;
    }

    .text-autospace {
        margin: 3px;
        padding: 3px;

        span {
            color: #515050;
            font-size: 14px !important;
        }
    }

    .icon {
        vertical-align: middle;
        margin-right: 2px;
    }

    .file-link-box {
        margin: 3px;
        padding: 3px;
        font-size: 14px;
        text-indent: 22px;
        line-height: 16px;
    }

    .file-link {
        font-size: 12px;
        color: #0066cc;
    }
}
</style>